import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { GetFormMasterComponent } from './formsMaster/components/get/get.component';
import { GetFormFieldComponent } from './formsFields/components/get/get.component';
import { GetSourceMasterComponent } from './source.master/components/get/get.component';
import { GetSourceValueComponent } from './sources.values/components/get/get.component';
import { GetFormMasterFieldsComponent } from './formsMaster/components/get.fields/get.component';
import { GetFormSectionComponent } from './forms.sections/components/get/get.component';

const routes: Routes = [
  {
    path: '',
    // component: DynamicFormsComponent,
    children: [
      {
        path: '',
        component: GetFormMasterComponent,
      },
      {
        path: 'sections/:sid/formsfields/:id',
        component: GetFormFieldComponent,
      },
      {
        path: 'sections/:id',
        component: GetFormSectionComponent,
      },
      {
        path: 'preview/:id',
        component: GetFormMasterFieldsComponent,
      },

      {
        path: 'sources',
        children: [
          {
            path: '',
            component: GetSourceMasterComponent,
          },
          {
            path: 'master/:id',
            component: GetSourceValueComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DynamicFormsRoutingModule {}
